var _defs, _rect, _text, _rect2, _rect3, _path, _rect4, _text2, _g, _g2, _path2, _g3, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowniverseLogoFullBordered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1037,
    height: 693,
    viewBox: "0 0 1037 693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke: #000;\r\n        stroke-linejoin: round;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-2 {\r\n        font-size: 6.458px;\r\n      }\r\n\r\n      .cls-14, .cls-2, .cls-5 {\r\n        font-family: Arial;\r\n      }\r\n\r\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-3, .cls-6, .cls-8, .cls-9 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-5 {\r\n        font-size: 25px;\r\n      }\r\n\r\n      .cls-14, .cls-5 {\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        fill: #263c7b;\r\n      }\r\n\r\n      .cls-6 {\r\n        filter: url(#filter);\r\n      }\r\n\r\n      .cls-7 {\r\n        filter: url(#filter-2);\r\n      }\r\n\r\n      .cls-8 {\r\n        filter: url(#filter-3);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #544c92;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #1f52a0;\r\n      }\r\n\r\n      .cls-14 {\r\n        font-size: 29.167px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 315,
    y: 107.906,
    width: 413,
    height: 372.094,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 315,
    y: 107.906,
    width: 413,
    height: 372.094,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDEzIiBoZWlnaHQ9IjM3Mi4wOTQiIHZpZXdCb3g9IjAgMCA0MTMgMzcyLjA5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHkxPSIxODYuMDQ3IiB4Mj0iNDEzIiB5Mj0iMTg2LjA0NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmJhNWUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjYzYzdiIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0MTMiIGhlaWdodD0iMzcyLjA5NCIvPgo8L3N2Zz4K"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 623.656,
    y: 132.812,
    width: 22.719,
    height: 22.626,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 623.656,
    y: 132.812,
    width: 22.719,
    height: 22.626,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjIuNzE5IiBoZWlnaHQ9IjIyLjYyNiIgdmlld0JveD0iMCAwIDIyLjcxOSAyMi42MjYiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iMTEuMzEzIiB4Mj0iMjIuNzE5IiB5Mj0iMTEuMzEzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmYmE1ZSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNjNjN2IiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjIyLjcxOSIgaGVpZ2h0PSIyMi42MjYiLz4KPC9zdmc+Cg=="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    x: 611.281,
    y: 163.656,
    width: 14.438,
    height: 14.406,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 611.281,
    y: 163.656,
    width: 14.438,
    height: 14.406,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTQuNDM4IiBoZWlnaHQ9IjE0LjQwNiIgdmlld0JveD0iMCAwIDE0LjQzOCAxNC40MDYiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iNy4yMDMiIHgyPSIxNC40MzgiIHkyPSI3LjIwMyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmJhNWUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjYzYzdiIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSIxNC40MzgiIGhlaWdodD0iMTQuNDA2Ii8+Cjwvc3ZnPgo="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 488,
    width: 1037,
    height: 205
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "A_Universe_Where_You_Grow",
    "data-name": "A Universe Where You Grow",
    className: "cls-2",
    transform: "translate(264.422 666) scale(6.004 6.452)"
  }, "A Universe Where You Grow")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 650,
    width: 217,
    height: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9_copy",
    "data-name": "Rectangle 9 copy",
    x: 785,
    y: 650,
    width: 217,
    height: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M490.185,1.656C651.072-15.688,795.293,98.228,812.312,256.1S712.7,556,551.815,573.344,246.707,476.772,229.688,318.9,329.3,19,490.185,1.656Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 312,
    y: 487.094,
    width: 416,
    height: 101.812
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "GROWNIVERSE",
    className: "cls-5",
    transform: "translate(23.828 612.461) scale(5.172 5.519)"
  }, "GROWNIVERSE")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385.52,124.4C241.679,324.442,462.545,522.047,617.271,406.358c80.737-65.8-.434-177.185,39.668-226.3,13.685-4.219,7.714,37.343,8.54,49.8,6.375,26.05,42.43-10.159,8.755-66.556-15.155-31.077-22.891-42.828-10.486-54.736C674.1,99.479,728.062,190.7,728,267.473c-3.643,80.518-34.678,192.022-197.378,211.86C348.491,493.886,233.4,263.465,385.52,124.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 635.015,
    cy: 144.125,
    r: 11.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M618.508,163.66a7.2,7.2,0,1,1-7.221,7.2A7.21,7.21,0,0,1,618.508,163.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M715.874,169.881s-22.468-19.8-26.192-54.662c0.878-11.334,15.5-2.09,13.08,2.136C699.4,131.511,715.874,169.881,715.874,169.881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M720.493,159.414c-1.237.312-8.763-9.425-9.5-27.073,0.675-15.548,11.711-10.958,11.135-2.8C721.337,137.88,721.731,159.1,720.493,159.414Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "globe_copy",
    "data-name": "globe copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M450.264,164.769S407,213.757,522.543,261.7c109.875,36.159,114.031-21.322,114.031-21.322s19.108,80.261-136.15,26.3C378.009,208.323,450.264,164.769,450.264,164.769Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M561.333,168.056H493.258l32.246,46.02,75.241,3.287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332.028,253.522"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M561.333,171.343a15.621,15.621,0,0,0,3.583-3.287c-9.636-7.73-83.3-22.188-85.989,6.574-5.485,45.828,102.757,75.987,125.4,52.6,23.843-34.446-38.474-58.495-38.474-58.495l-5.027,2.613s56.936,25.749,39.918,46.02c-26.016,31.432-113.717-15.544-111.07-39.446C494.154,144.772,561.333,171.343,561.333,171.343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M367.857,263.383S361.587,316.251,475.344,362c97.932,34.789,146.9-3.287,146.9-3.287S589.1,411.305,464.6,368.572C344.569,321.456,367.857,263.383,367.857,263.383Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M392.938,365.285C441.642,434.828,547,411.305,547,411.305S449.293,424.282,392.938,365.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M539.836,191.066C422.8,254.07,405.179,381.72,407.269,381.72,409.061,382.268,442.053,258.042,539.836,191.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M532.67,184.492c-17.317-8.218-170.187,22.736-154.064,154.5C381.592,213.254,507.291,187.505,532.67,184.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_copy",
    "data-name": "Shape 11 copy",
    className: "cls-10",
    d: "M548.288,193.153c6.139,124.371-100.963,207.441-102.1,205.832C444.71,397.905,540.309,304.869,548.288,193.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M396.52,204.214S378.094,254.461,489.675,309.4c107.764,43.956,154.064-6.574,154.064-6.574s-31.414,67.015-161.229,16.436C356.725,261.505,396.52,204.214,396.52,204.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_copy",
    "data-name": "Shape 12 copy",
    className: "cls-10",
    d: "M566.083,199.4c16.552,9.452,61.246,164.437-73.1,213.619C616.69,348.569,576.237,220.955,566.083,199.4Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M697.483,470.474"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M438.731,160.762V111.455s13.623-29.413,79.608-28.865,82.07,28.865,82.07,28.865v53.314s-27.133-19.723-82.07-19.723C457.131,145.046,438.731,160.762,438.731,160.762Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M375.023,82.59L525.5,30,668.82,92.451l-57.327,19S586.115,73,521.921,72.729c-67.179-.274-86.773,32.871-86.773,32.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M396.962,82.955h7.208v66.13h-7.208V82.955Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M396.52,135.184V151.62s-8.7,9.656-8.7,13.149v9.861h24.556v-9.861c0-3.8-8.7-13.149-8.7-13.149V135.184H396.52Z"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "TM",
    className: "cls-14",
    x: 641.481,
    y: 489.097
  }, "TM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowniverseLogoFullBordered);
export default __webpack_public_path__ + "static/media/growniverse-logo-full-bordered.29d1c7e967bb00da995767724889ea4d.svg";
export { ForwardRef as ReactComponent };